module.exports = __webpack_public_path__ + "static/media/agile.af4e50f0.jp2";